<template>
    <div class="page">
        <div class="userinfo-box df">
            <div class="left-box fn">
                <div class="list" :class="{ 'active': currentIndex == 0 }" @click="currentIndex = 0">
                    <span class="iconfont icon-icon4"></span>
                    <span class="text">{{ $t('资料') }}</span>
                </div>
                <div class="list" :class="{ 'active': currentIndex == 1 }" @click="currentIndex = 1">
                    <span class="iconfont icon-icon1"></span>
                    <span class="text">{{ $t('账号') }}</span>
                </div>
                <div class="list" :class="{ 'active': currentIndex == 2 }" @click="currentIndex = 2">
                    <span class="iconfont icon-icon3"></span>
                    <span class="text">{{ $t('我的收藏') }}</span>
                </div>
                <div class="list" :class="{ 'active': currentIndex == 3 }" @click="currentIndex = 3">
                    <span class="iconfont icon-icon5"></span>
                    <span class="text">{{ $t('我的贡献值') }}</span>
                </div>
                <div class="list" :class="{ 'active': currentIndex == 4 }" @click="currentIndex = 4">
                    <span class="iconfont icon-icon2"></span>
                    <span class="text">{{ $t('我的文章') }}</span>
                </div>
                <div class="list" :class="{ 'active': currentIndex == 5 }" @click="currentIndex = 5">
                    <span class="iconfont icon-xiaoxi1"></span>
                    <span class="text">{{ $t('我的讨论') }}</span>
                </div>
                <div class="list" :class="{ 'active': currentIndex == 6 }" @click="currentIndex = 6">
                    <span class="iconfont icon-icon7"></span>
                    <span class="text">{{ $t('我的活动') }}</span>
                </div>

            </div>

            <div class="right-box f1">
                <!-- 资料 -->
                <information v-if="currentIndex == 0" />

                <!-- 账号 -->
                <account v-if="currentIndex == 1" />

                <!-- 我的收藏 -->
                <collection v-if="currentIndex == 2" />

                <!-- 我的贡献值 -->
                <contribute v-if="currentIndex == 3" />

                <!-- 我的文章  -->
                <articles v-if="currentIndex == 4" />

                <!-- 我的讨论 -->
                <discuss v-if="currentIndex == 5" :data="data" />


                <active v-if="currentIndex == 6" :data="data" />
            </div>
        </div>
    </div>

</template>

<script>
import { getcommonData } from "@api/home";
// 引入组件account
import account from './components/account'
import information from './components/information'
import collection from './components/collection'
import contribute from './components/contribute'
import articles from './components/article'
import discuss from './components/discuss'
import active from './components/active'


export default {
    // 注册组件
    components: {
        information, account, collection, contribute, articles, discuss, active
    },
    data() {
        return {
            currentIndex: 0,

        }
    },
    created() {

         const datas = {
             tre_ep: "tre_ep",
         }

         this.insertScript("/static/raffle/index.js", JSON.stringify(datas), function () {
         })


        setTimeout(() => {
            this.$bus.$emit('changeNavbg', 'rgba(255, 255, 255, 1);');
        }, 600);

        this.getData();
    },
    methods: {

        async getData() {
            let res = await getcommonData();
            if (res.status == 200) {
                this.data = res.data;
            }

        },

        insertScript(path, data, callback) {
             var new_element = document.createElement("script");
             new_element.setAttribute("type", "text/javascript");
             new_element.setAttribute("src", path);
             new_element.setAttribute("data-param", data);
             new_element.onload = callback; // 加载完成后调用回调
             document.body.appendChild(new_element);
         }

    }

}
</script>

<style lang="scss" scoped>
.right-box {
    margin-left: 24px;
    background: #ffffff;
    border-radius: 6px 6px 6px 6px;
    padding: 24px;
    padding: 32px 60px 180px !important;
    width: calc(100% - 296px);
}

.page {
    min-height: calc(100vh - 280px);
    background-image: linear-gradient(180deg, #eff4fe 0%, #f8f8f8 100%);
    padding: 60px 80px 115px;

    .userinfo-box {
        padding-top: 63px;
        max-width: 1400px;
        margin: 0 auto;

    }

    .left-box {
        width: 272px;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        padding: 32px 24px 24px;
        height: fit-content;
        .list {
            height: 56px;
            line-height: 56px;
            border-radius: 8px 8px 8px 8px;
            margin-bottom: 8px;
            padding-left: 18px;
            position: relative;
            overflow: hidden;
            cursor: pointer;
            z-index: 1;
            transition: all 0.4s;

            &::after {
                content: "";
                display: block;
                width: 0;
                height: 100%;
                background: #FFF3F2;
                position: absolute;
                left: 0;
                top: 0;
                z-index: -1;
                transition: all 0.36s;
            }

            &.active,
            &:hover {
                padding-left: 24px;

                .iconfont,
                .text {
                    color: #b7251e;
                }

                &::after {
                    width: 100%;
                }
            }

            .iconfont {
                font-size: 16px;
                display: inline-block;
                margin-right: 18px;
                color: #858d9e;
            }

            .personal-box .left-box .list .text {
                font-size: 16px;
                color: #858d9e;
            }

        }
    }
}
</style>